import * as imprintDisclaimer from './imprint-disclaimer'
import * as terms from './terms'

export const contentHelper = {
  imprintDisclaimer,
  terms,
}
